<template>
  <div
    v-if="!iframeLink"
    class="d-flex justify-center align-center"
    :style="`height: ${contentHeight}px`"
  >
    <v-progress-circular indeterminate color="primary" />
  </div>
  <iframe v-else width="100%" :height="`${contentHeight}px`" :src="iframeLink" />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'IframeStep',
  props: {
    storePath: {
      type: String,
      required: true
    },
    iframeLink: {
      type: String,
      default: null
    },
    dialogTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      contentHeight: 550
    };
  },
  computed: {
    ...mapGetters({
      windowSize: 'general/windowSize'
    }),
    dialogWidth() {
      return this.$store.getters[`${this.storePath}/dialogWidth`];
    },
    dialogHeaderType() {
      return this.$store.getters[`${this.storePath}/dialogHeaderType`];
    },
    dialogContentJustify() {
      return this.$store.getters[`${this.storePath}/dialogContentJustify`];
    },
    dialogContentDisplayClasses() {
      return this.$store.getters[`${this.storePath}/dialogContentDisplayClasses`];
    }
  },
  watch: {
    windowSize: {
      deep: true,
      handler() {
        this.setSizedStoreVariables();
      }
    }
  },
  mounted() {
    this.setDialogTitle(this.dialogTitle);
    this.setSizedStoreVariables();
  },
  methods: {
    setDialogHeaderType(dialogHeaderType) {
      this.$store.dispatch(`${this.storePath}/setDialogHeaderType`, dialogHeaderType);
    },
    setDialogTitle(dialogTitle) {
      this.$store.dispatch(`${this.storePath}/setDialogTitle`, dialogTitle);
    },
    setDialogContentJustify(dialogContentJustify) {
      this.$store.dispatch(`${this.storePath}/setDialogContentJustify`, dialogContentJustify);
    },
    setDialogContentDisplayClasses(dialogContentDisplayClasses) {
      this.$store.dispatch(
        `${this.storePath}/setDialogContentDisplayClasses`,
        dialogContentDisplayClasses
      );
    },
    setSizedStoreVariables() {
      this.setDialogHeaderType(this.windowSize.x < this.dialogWidth ? 'navigation' : 'none');
      this.setDialogContentJustify(this.windowSize.x < this.dialogWidth ? 'center' : 'start');

      const dialogHeaderElement = document.querySelector('.dialog-header');

      this.setDialogContentDisplayClasses(
        dialogHeaderElement &&
          this.windowSize.y - dialogHeaderElement.clientHeight < this.contentHeight
          ? 'd-block'
          : 'd-flex'
      );
    }
  }
};
</script>
